import React from 'react'
import '../common/common.scss'

const ChartError = ({ className = '', message = "Couldn't load this chart. Please try again." }) => {
  return (
    <div className={`chart-error-container ${className}`.trim()}>
      <p className="chart-error-text">{message}</p>
    </div>
  )
}

export default ChartError
